import Link from 'next/link';
import { WideProjectElementSchema } from '../../schema/pageElements.val';
import HotspotImage from '../HotspotImage';
import ProjectTitle from './ProjectTitle';
import ProjectClient from './ProjectClient';
import ProjectServices from './ProjectServices';

interface WideProjectProps extends WideProjectElementSchema {
  priority?: boolean;
}

const WideProjectElement: React.FC<WideProjectProps> = ({
  image,
  projectTitle,
  clientName,
  url,
  services,
  priority = false,
}) => {
  return (
    <div className="flex flex-col w-full laptop:px-[96px] px-0 group">
      <ProjectClient clientName={clientName} />
      <ProjectTitle title={projectTitle} />
      <Link href={url} className="relative aspect-[23/10] overflow-hidden">
        <div className="transform transition-transform duration-1000 ease-spring group-hover:scale-105">
          {image && (
            <HotspotImage
              priority={priority}
              image={image}
              setAspectRatio={'aspect-[23/10]'}
            />
          )}
          <div className="absolute inset-0 bg-white opacity-0 duration-1000 ease-spring group-hover:opacity-[0.03] pointer-events-none z-10" />
        </div>
      </Link>
      <ProjectServices services={services} />
    </div>
  );
};

export default WideProjectElement;
